"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storeEnvironmentConfig = void 0;

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var storeEnvironmentConfig = function storeEnvironmentConfig(config) {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.INITIALIZE_CONFIG,
      config: config
    });
  };
};

exports.storeEnvironmentConfig = storeEnvironmentConfig;


//////////////////
// WEBPACK FOOTER
// ./js/actions/ConfigActions.js
// module id = 545
// module chunks = 5 6